import script from "./addResults.vue?vue&type=script&setup=true&lang=js"
export * from "./addResults.vue?vue&type=script&setup=true&lang=js"

import "./addResults.vue?vue&type=style&index=0&id=33ccc5bc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33ccc5bc"]])

export default __exports__